import styled, { mediaQuery, css } from 'academy-common-lib/utils/Styling';
import UICardGrid from 'UIComponents/card/UICardGrid';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCardGrid = styled(UICardGrid).withConfig({
  displayName: "RecommendationsGrid__StyledCardGrid",
  componentId: "sc-1awe09a-0"
})(["grid-template-columns:1fr;", ""], mediaQuery('desktop', css(["grid-template-columns:repeat(3,1fr);"])));
export const RecommendationsGrid = ({
  children
}) => {
  return /*#__PURE__*/_jsx(StyledCardGrid, {
    gutterSize: 24,
    children: children
  });
};